<template>
  <div class="yuanzhu-website">
    <div class="layout-header">
      <div class="top align-center">
        <div class="left" @click="handleLogo()">
          <img src="~/assets/logo.svg" />
        </div>
        <div class="middle font-18">
          <div
            v-for="(item, index) in activeTab"
            :key="index"
            class="tab-text"
            :class="activeKey == item.key ? 'tab-text-active' : ''"
            @click="jumpPage(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="right">
          <div class="lang-content">
            <div class="lang_box" :class="activeLang == 'zh' ? 'lang_box_active' : ''" @click="changeLang('zh')">
              中文
            </div>
            <div class="lang_line">/</div>
            <div class="lang_box" :class="activeLang == 'en' ? 'lang_box_active' : ''" @click="changeLang('en')">
              ENG
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <a-spin :spinning="spinning">
        <router-view :key="$route.fullPath" />
      </a-spin>
    </div>
    <div v-if="!['about'].includes(activeKey)" class="layout-footer">
      <div class="w1200">
        <div class="flex-between">
          <div class="flex">
            <div class="logo_footer">
              <img src="~/assets/logo_footer.svg" />
            </div>
            <div class="message_box">
              <div class="message_content align-center">
                <div>
                  <img src="~/assets/weixin.svg" />
                </div>
                <div class="ml-20 mr-10">gaoxiaoyu5138</div>
                <a-popover placement="top">
                  <template slot="content">
                    <div class="text-center">
                      <img src="~/assets/weixin_code.png" width="135" height="136" />
                      <div class="weixin_name">高晓宇 Monica</div>
                      <div class="weixin_position">
                        {{ $t('home.footer_weixin_position') }}
                      </div>
                    </div>
                  </template>
                  <img src="~/assets/weixin_icon.svg" />
                </a-popover>
              </div>
              <div class="message_content">
                <img src="~/assets/phone.svg" />
                <span class="ml-20">+62 812 8603 5248 /+86 13051888797</span>
              </div>
              <div class="message_content">
                <img src="~/assets/message.svg" />
                <span class="ml-20">marketing@yardzeal.id</span>
              </div>
              <div class="message_content flex">
                <div>
                  <img src="~/assets/loaction_footer.svg" />
                </div>
                <div>
                  <div
                    v-for="(item, index) in commonAddresses"
                    :key="index"
                    class="flex address-row"
                    :class="{ 'mt-10': index > 0 }"
                  >
                    <div class="ml-20 address-line">
                      <span>{{ item.country }}</span>
                      <span class="address-divider">|</span>
                      <span>{{ item.detail }}</span>
                    </div>
                  </div>
                  <div class="more-countries ml-20 mt-10" @click="handleShowCountryAddress">
                    <span>{{ $t('home.footer_more_countries') }}</span>
                    <span class="more-countries-arrow">→</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="mr-40 text-center">
              <img src="~/assets/public_account.png" class="hover_big" loading="lazy" decoding="async" />
              <div class="mt-20">
                {{ $t('home.footer_public_account') }}
              </div>
            </div>
            <div class="mr-40 text-center">
              <img src="~/assets/weixin_video.svg" class="hover_big" loading="lazy" decoding="async" />
              <div class="mt-20">
                {{ $t('home.footer_weixin_video') }}
              </div>
            </div>
            <div class="text-center">
              <img src="~/assets/tik_tok.svg" class="hover_big" loading="lazy" decoding="async" />
              <div class="mt-20">
                {{ $t('home.footer_tik_tok') }}
              </div>
            </div>
          </div>
        </div>
        <div class="long_line"></div>
        <div class="flex-between">
          <div style="color: #acafb9">©YARD ZEAL INDONESIA, powered by SHANHAI MAP THX</div>
          <div style="color: #acafb9">
            Copyright © www.yuanzhu-co.com 源筑地产
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025407399号-1</a>
          </div>
          <div>
            {{ $t('home.footer_links') }}
            <span style="cursor: pointer" @click="jumpShangMap">
              <img src="~/assets/shangmap.svg" />
              <span style="color: #01afc8">
                {{ $t('home.footer_shangmap') }}
              </span>
            </span>
          </div>
        </div>
        <div class="mt-10 align-center">
          <img width="18" height="20" src="~/assets/home/beian.png" class="mr-10" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002006854" rel="noreferrer" target="_blank">
            粤公网安备44030002006854号
          </a>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div v-show="!['home', 'about', 'bpartner', 'pk'].includes(activeKey)" class="contract-content">
      <a-tooltip>
        <template slot="title">
          <span> {{ $t('detail.list_contract') }} </span>
        </template>
        <div class="contract_box" @click="handleContactUs">
          <img src="~/assets/house/customer.webp" />
          <div class="contract_title">{{ $t('detail.contact_us') }}</div>
        </div>
      </a-tooltip>
    </div>
    <CountryAddress ref="countryAddress"></CountryAddress>
    <ContactUs ref="contact"></ContactUs>
  </div>
</template>
<script>
import { i18n } from '~/plugins/i18n'
import ContactUs from '~/components/contactUs.vue'
import CountryAddress from '~/components/countryAddress.vue'
import { getCommonAddresses } from '~/utils/countryAddress'
import { mapNavActiveKey } from '~/utils/houseType'
export default {
  components: { ContactUs, CountryAddress },
  name: 'default',
  data() {
    return {
      activeKey: 'home',
      activeLang: 'zh',
      visible: false,
      spinning: false,
    }
  },
  created() {
    if (this.$route.name == 'detail') {
      this.activeKey = mapNavActiveKey(this.$route.query.type)
    } else {
      this.activeKey = mapNavActiveKey(this.$route.name)
    }
    this.activeLang = this.$i18n.locale
    i18n.locale = this.$i18n.locale
  },
  computed: {
    commonAddresses() {
      return getCommonAddresses(this.$store.state.addressList)
    },
    activeTab() {
      return [
        {
          key: 'home',
          name: this.$t('home.home'),
          path: '/home',
        },
        {
          key: 'Office',
          name: this.$t('detail.list_commercial'),
          path: '/house/office',
        },
        {
          key: 'Factory',
          name: this.$t('detail.list_factory'),
          path: '/house/factory',
        },
        {
          key: 'Warehouse',
          name: this.$t('detail.list_warehouse'),
          path: '/house/warehouse',
        },
        {
          key: 'Land',
          name: this.$t('detail.list_land'),
          path: '/house/land',
        },
        {
          key: 'bpartner',
          name: 'B Partner',
          path: '/bpartner',
        },
        {
          key: 'about',
          name: this.$t('about.about'),
          path: '/about',
        },
      ]
    },
  },
  watch: {
    $route: function (newVal) {
      if (this.$route.name == 'detail') {
        this.activeKey = mapNavActiveKey(newVal.query.type)
      } else {
        this.activeKey = mapNavActiveKey(newVal.name)
      }
    },
  },
  methods: {
    jumpShangMap() {
      window.open('https://www.shanhaimap.com')
    },
    jumpPage(item) {
      this.$router.push({ path: item.path })
    },
    changeLang(type) {
      this.$i18n.locale = type
      localStorage.setItem('locale', type)
      window.location.reload()
    },
    handleContactUs() {
      this.$refs.contact.show()
    },
    handleShowCountryAddress() {
      this.$refs.countryAddress.show()
    },
    handleLogo() {
      this.activeKey = ''
      this.spinning = true
      window.location.href = '/home'
    },
  },
}
</script>
<style lang="less" scoped>
.yuanzhu-website {
  font-family: PingFang SC, PingFang SC;
}
.layout-header {
  min-width: 1254px;
  width: 100%;
  height: 84px;
  color: #000000;
  background: #ffffff;
  position: fixed;
  top: 0;
  z-index: 999;
  .top {
    padding: 0 300px;
    position: relative;
    height: 84px;
    .left {
      position: absolute;
      left: 100px;
      cursor: pointer;
      width: 80px;
    }
    .right {
      position: absolute;
      right: 30px;
      display: flex;
    }
    .middle {
      width: 1200px;
      margin: auto;
      display: flex;
      .tab-text {
        white-space: nowrap;
        margin-right: 40px;
        cursor: pointer;
      }
      .tab-text-active {
        color: #01afc8;
      }
    }
  }
}
.lang-content {
  display: flex;
  align-items: center;
  margin-left: 27px;
  .lang_line {
    margin: 0 5px;
  }
  .lang_box {
    cursor: pointer;
  }
  .lang_box_active {
    color: #01afc8;
  }
}
.layout-content {
  width: 100%;
  min-width: 1254px;
  min-height: 100vh;
  background: #f3f4f9;
  color: #000000;
  margin-top: 84px;
}
.layout-footer {
  width: 100%;
  min-width: 1254px;
  background: #232c46;
  color: #fff;
  padding-top: 44px;
  padding-bottom: 17px;
  .long_line {
    width: 1199px;
    height: 0px;
    border: 1px solid #ffffff;
    opacity: 0.1;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  .message_box {
    font-size: 14px;
    color: #ffffff;
    margin-left: 80px;
    .message_content {
      padding: 10px 0;
      .weixin_name {
        font-size: 14px;
        color: #000000;
        line-height: 16px;
      }
      .weixin_position {
        font-size: 12px;
        color: #a6a6a7;
      }
    }
    .address-line {
      line-height: 20px;
      word-break: break-word;
      .address-divider {
        margin: 0 8px;
      }
    }
    .more-countries {
      display: inline-flex;
      align-items: center;
      color: #01afc8;
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      user-select: none;
      &:hover {
        opacity: 0.85;
      }
      .more-countries-arrow {
        margin-left: 4px;
        font-size: 14px;
      }
    }
  }
  .hover_big {
    width: 120px;
  }
  .hover_big:hover {
    width: 180px;
  }
}
// 联系我们
.contract-content {
  position: fixed;
  right: 27px;
  bottom: 400px;
  .contract_box {
    width: 180px;
    height: 70px;
    display: flex;
    align-items: center;
    background: linear-gradient(to right, #ff7b5e, #ffa34f);
    box-shadow: 4px 0 8px 0 rgba(227, 87, 56, 0.29);
    border-radius: 50px;
    padding: 8px;
    cursor: pointer;
    .contract_title {
      font-size: 18px;
      color: #fff;
      margin-left: 10px;
    }
  }
}
.logo_footer {
  width: 120px;
}
</style>
<style lang="less">
.ant-tooltip-content {
  width: 200px !important;
  border-radius: 4px !important;
  line-height: 24px;
  .ant-tooltip-inner {
    background-color: #365d82 !important;
  }
}
.ant-modal-content {
  border-radius: 8px !important;
  .ant-modal-body {
    padding: 0 !important;
  }
}
</style>